import { cn } from "@/lib/cn";

interface Props {
  /** CSS color value, e.g. "var(--st-run)" or "var(--brand)" */
  color: string;
  /** animate a ping ring + pulse for actively-running states */
  live?: boolean;
  size?: number;
  className?: string;
}

/**
 * Status dot. When `live`, it emits an expanding ping ring — the small,
 * repeated echo of the deleggate mark's orbit node that signals live dispatch.
 */
export function LiveDot({ color, live = false, size = 8, className }: Props) {
  return (
    <span
      className={cn("relative inline-flex shrink-0", className)}
      style={{ width: size, height: size }}
    >
      {live && (
        <span
          className="dgg-ping absolute inset-0 rounded-full"
          style={{ background: color }}
        />
      )}
      <span
        className={cn("relative inline-flex rounded-full", live && "dgg-pulse")}
        style={{ width: size, height: size, background: color }}
      />
    </span>
  );
}
